import {PermissionType, RoleBasedPermission} from '@hconnect/apiclient'

export const MAX_MATERIAL_NAME_LENGTH = 255

// Plant Controller and CCC Supporter must have the same material management
// permissions as Plant Director. CHANGE_MATERIALS is kept for backward
// compatibility with users who are still only granted the legacy permission.
export const CHANGE_MATERIALS_PERMISSION_TYPES: [PermissionType, ...PermissionType[]] = [
  'CHANGE_MATERIALS',
  RoleBasedPermission.HproduceRolePlantController,
  RoleBasedPermission.HproduceRoleCCCSupporter
]
